/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import React from "react";
import ProfileImg from "../ui/icons/ProfileImg";

const MemberCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    const displayName = value?.name || value?.externalId || "-";

    return (
      <span className="flex items-center gap-3 max-w-full">
        <ProfileImg
          desc={value?.desc}
          img={value?.img}
          name={displayName}
          size="sm"
          width={32}
          height={32}
          rounded={false}
        />
        <span className="text-sm font-medium text-gray-900 truncate">{displayName}</span>
      </span>
    );
  },
);

export default MemberCell;
